import {
  MODIFY_CHARGE,
  COPY,
  CUT,
  SET_ELEMENT,
  ESCAPE,
  KEY_DOWN_EVENT,
  CLEAR_CHARGE,
  PASTE,
  REDO,
  RELAX,
  REMOVE,
  SELECT_ALL,
  UNDO,
  REDRAW,
} from '../../../etc/constants';
import { namedMols } from '@moleculeone/draw';
import { setFragmentBondMode } from '../molecule-object.actions';

function plainEffect(state: any, action: any) {
  switch (action.key) {
    case '3':
    case '4':
    case '5':
    case '6':
    case '7':
    case '8':
    case '9': {
      const frag = namedMols.cycloalkanes[action.key as keyof typeof namedMols.cycloalkanes];
      return setFragmentBondMode(frag, Object.keys(frag.bonds)[0]);
    }
    case 'b':
    case 'c':
    case 'n':
    case 'o':
    case 'f':
    case 'p':
    case 's':
    case 'i':
      return { type: SET_ELEMENT, element: action.key.toUpperCase() };
    case 'r':
      return { type: SET_ELEMENT, element: 'Br' };
    case 'l':
      return { type: SET_ELEMENT, element: 'Cl' };
    case 'd':
    case 'Delete':
      return { type: REMOVE };
    case '0':
      return { type: CLEAR_CHARGE };
    case '+':
    case '=':
      return { type: MODIFY_CHARGE, change: 1 };
    case '-':
    case '_':
      return { type: MODIFY_CHARGE, change: -1 };
    case 'Escape':
      return { type: ESCAPE };
    case 'q':
      return { type: RELAX };
    case ' ':
      return { type: REDRAW };
    default:
      return null;
  }
}

function ctrlEffect(state: any, action: any) {
  switch (action.key) {
    case 'c':
      return { type: COPY };
    case 'x':
      return { type: CUT };
    case 'v':
      return { type: PASTE };
    case 'a':
      return { type: SELECT_ALL };
    case 'z':
      return { type: UNDO };
    case 'y':
      return { type: REDO };
    default:
      return null;
  }
}

function shiftCtrlEffect(state: any, action: any) {
  switch (action.key) {
    case 'Z':
      return { type: REDO };
    default:
      return null;
  }
}

export function interpretKeys(state: any, action: any) {
  if (action.type !== KEY_DOWN_EVENT) {
    return action;
  }

  let result: ReturnType<typeof plainEffect> | ReturnType<typeof ctrlEffect> | ReturnType<typeof shiftCtrlEffect> | null = null;
  if (!action.ctrlKey) {
    result = plainEffect(state, action);
  } else if (action.ctrlKey && !action.shiftKey) {
    result = ctrlEffect(state, action);
  } else if (action.ctrlKey && action.shiftKey) {
    result = shiftCtrlEffect(state, action);
  }

  // if (result != null) {
  //   console.log(action)
  //   result.mouse = action.mouse;
  // }
  return result;
}
